import { render, staticRenderFns } from "./PopupPleaseAwait.vue?vue&type=template&id=531064e6"
import script from "./PopupPleaseAwait.vue?vue&type=script&lang=js"
export * from "./PopupPleaseAwait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports